<script setup lang="ts">
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import { useTranslations } from '@/composables/useTranslations';

const page = usePage();
const { t, tList } = useTranslations();

const howToStepsKey = computed(() => {
    let path = (page.url || '').split('?')[0].replace(/^\/+/, '');
    path = path.replace(/^(en|sr)\//, '');

    if (path.startsWith('tools/pdf/')) {
        return path.slice('tools/pdf/'.length).replace(/-/g, '_');
    }

    if (path.startsWith('tools/image/')) {
        return 'image_' + path.slice('tools/image/'.length).replace(/-/g, '_');
    }

    return null;
});

const howToSteps = computed(() =>
    howToStepsKey.value
        ? tList(
              `tools.how_to.steps.${howToStepsKey.value}`,
              tList('tools.how_to.default'),
          )
        : tList('tools.how_to.default'),
);
</script>

<template>
    <aside
        class="rounded-xl border border-border bg-card p-4 shadow-sm sm:p-5"
        aria-labelledby="how-to-heading"
    >
        <h2
            id="how-to-heading"
            class="text-xs font-semibold tracking-wide text-gray-900 uppercase sm:text-sm dark:text-gray-100"
        >
            {{ t('tools.how_to.title', 'How to use this tool') }}
        </h2>
        <ol
            class="mt-3 space-y-2.5 text-xs leading-relaxed text-gray-600 sm:text-sm dark:text-gray-300"
        >
            <li
                v-for="(step, index) in howToSteps"
                :key="step"
                class="break-words"
            >
                <span
                    class="mr-1.5 font-medium text-gray-900 tabular-nums sm:mr-2 dark:text-gray-100"
                >
                    {{ index + 1 }}.
                </span>
                {{ step }}
            </li>
        </ol>
    </aside>
</template>
